export default __webpack_public_path__ + "static/media/pexels-andrea-imre-10550212.085ca050.jpg";